// extracted by mini-css-extract-plugin
export var sliderRange = "_md-2";
export var sliderRoot = "_md-0";
export var sliderThumb = "_md-3";
export var sliderTrack = "_md-1";